"use strict";Object.defineProperty(exports, "__esModule", {value: true});

 const TRIAL_START_FAILED_NOTICE =
  "We couldn't start your trial — you can start it anytime from Settings → Plan."; exports.TRIAL_START_FAILED_NOTICE = TRIAL_START_FAILED_NOTICE

const key = (orgKey) => `onb_ready_notice_${orgKey}`

 const setTrialStartFailedNotice = (orgKey) => {
  try {
    sessionStorage.setItem(key(orgKey), '1')
  } catch (e) {
    // best-effort
  }
}; exports.setTrialStartFailedNotice = setTrialStartFailedNotice

 const consumeTrialStartFailedNotice = (orgKey) => {
  try {
    const exists = sessionStorage.getItem(key(orgKey))
    sessionStorage.removeItem(key(orgKey))
    return exists ? exports.TRIAL_START_FAILED_NOTICE : undefined
  } catch (e2) {
    return undefined
  }
}; exports.consumeTrialStartFailedNotice = consumeTrialStartFailedNotice
